export default __webpack_public_path__ + "static/media/4.bfd058ab.jpeg";